import { Badge, Icon, Image, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { ReactComponent as PlayersIcon } from '../../assets/icons/PlayersIcon.svg'; // This is imported as React Component for it to be able to be a svg in the genrated HTML
import ViewIcon from '../../assets/icons/ViewIcon.svg';
import ViewIconOffline from '../../assets/icons/ViewIconOffline.svg';

type GenericCountBadgeProps = (
    | {
          onlineStatus: true;
          count: number | undefined;
      }
    | { onlineStatus: false }
) & {
    width?: string;
    icon?:
        | string
        | React.FunctionComponent<
              React.SVGProps<SVGSVGElement> & {
                  title?: string | undefined;
              }
          >;
};

interface CountBadgeProps {
    count: number | undefined;
    width?: string;
}

export const PlayerBadge: React.FC<CountBadgeProps> = ({ count, width }) => (
    <GenericCountBadge onlineStatus={true} count={count} icon={PlayersIcon} width={width} />
);

export const ViewerBadge: React.FC<CountBadgeProps> = ({ count, width }) => (
    <GenericCountBadge onlineStatus={true} count={count} width={width} icon={ViewIcon} />
);

export const OfflineBadge: React.FC<{}> = () => (
    <GenericCountBadge onlineStatus={false} width={'100%'} icon={ViewIconOffline} />
);

const GenericCountBadge: React.FC<GenericCountBadgeProps> = (props) => {
    const [message, setMessage] = useState('');
    const [borderColor, setBorderColor] = useState('');
    const [count] = useState(props.onlineStatus ? props.count : 0);

    let textClassName = props.onlineStatus ? 'live-six-text' : 'offline-six-text';

    useEffect(() => {
        if (props.onlineStatus) {
            setBorderColor('1px solid #6EF1D5');
            setMessage(count !== undefined ? count.toString() : '-');
        } else {
            setBorderColor('1px solid #FE8FB6');
            setMessage('offline');
        }
    }, [props.onlineStatus, count]);

    return (
        <Badge
            className={`live-six-${props.icon === PlayersIcon ? 'players' : 'viewers'} ${
                !props.onlineStatus ? 'offline' : ''
            }`}
            width={props.width}
            border={borderColor}
            borderRadius={'2em'}
        >
            {typeof props.icon === 'string' ? (
                <Image src={props.icon} className={`live-viewers-icon`} />
            ) : (
                <Icon as={props.icon} className={'live-viewers-con'} />
            )}
            <Text className={textClassName}>{message}</Text>
        </Badge>
    );
};
